/*
Whether the visitor is allowed to see the coupon / gift layer of the buyer site at all.

A coupon or a free gift is something a REGISTERED buyer earns on an order they place. A guest -
either a plain logged-out visitor or a temp OTP session (`temp_token`), neither of which can place
an order - has nothing to redeem, so the whole campaign layer is withheld from them rather than
shown blurred or value-less:

  - the "Coupons & Gifts" tab in the buyer dashboard header
  - the card frame, the corner ribbon and the seller-pill price tag (components/CampaignFrame)
  - the product-tier offer strip on a card (components/OfferPanel)
  - the coupon / gift row on the product detail page
  - the "Coupons & Gifts" bucket in the search filters (bSearchResults/categoryList)

The gate is the buyer's own token. `temp_token` deliberately does NOT count: it is the guest
session (see util/useTempTokenExpiry), and the API withholds campaign values from it anyway.

Read at render time rather than captured once, so signing in or out repaints correctly without a
reload the same way the rest of the buyer UI does.
*/
export const campaignsVisible = () => Boolean(localStorage.getItem('buyer_token'));

export default campaignsVisible;
